export function formatDate(dateStr: string, locale: "ru" | "en"): string {
  const date = new Date(dateStr);

  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function getWeekdayName(
  dateStr: string,
  locale: "uk" | "ru" | "en" = "uk",
  weekday: Intl.DateTimeFormatOptions["weekday"] = "long"
): string {
  const date = new Date(dateStr);

  if (isNaN(date.getTime())) return "";

  return new Intl.DateTimeFormat(locale, { weekday: weekday }).format(date);
}

export function formatLocalDate(date: Date, separator = "-"): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}${separator}${month}${separator}${day}`;
}

export function datePartsToString(
  day: number,
  month: number,
  year: number,
  separator = "-"
) {
  const formattedDay = String(day).padStart(2, "0");
  const formattedMonth = String(month).padStart(2, "0");

  return `${formattedDay}${separator}${formattedMonth}${separator}${year}`;
}

export function isSameDates(first: Date, second: Date) {
  return (
    first.getDate() === second.getDate() &&
    first.getMonth() === second.getMonth() &&
    second.getFullYear() === first.getFullYear()
  );
}

export function normalizeStringDate(stringDate: string) {
  const normalized = stringDate.replace(/[./]/g, "-");
  const parts = normalized.split("-");

  if (parts.length !== 3) return null;

  const isYearFirst = parts[0].length === 4;
  const isYearLast = parts[2].length === 4;

  if (!isYearFirst && !isYearLast) return null;

  const dayStr = isYearFirst ? parts[2] : parts[0];
  const yearStr = isYearFirst ? parts[0] : parts[2];

  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(dayStr, 10);
  const year = parseInt(yearStr, 10);

  const date = new Date(year, month, day);

  return isNaN(date.getTime()) ? null : date;
}
